import React, { Component } from 'react';
import { Popover, PopoverInteractionKind, Position } from "@blueprintjs/core";
import { DatePicker } from '@blueprintjs/datetime';

class PopOverCalendar extends Component {
	state = {
		'isOpen': false
	}

	render() { 
		const { locale, value, disabled } = this.props;
		if(disabled === true) {
			return <button className="pt-icon-calendar pt-button pt-intent-primary pt-disabled" />
		}
		return 	<Popover
			interactionKind={PopoverInteractionKind.CLICK}
			popoverClassName="pt-over-content-sizing"
			onInteraction = { this.pickerToggle }
			isOpen = { this.state.isOpen }
			content={
				<DatePicker
					canClearSelection={true}
					showActionsBar={true}
					locale={locale}
					value = {value}
					onChange = {this.onChange}
				/>
			}
			position='auto'
			>
			<button className="pt-icon-calendar pt-button pt-intent-primary" />
		</Popover>
	}
	
	onChange = (newDate, hasUserManuallySelectedDate) => {
		const { onChange } = this.props;
		if(hasUserManuallySelectedDate === true) {
			if(newDate !== null) {
				onChange(newDate);
			}
			this.pickerToggle(false);
		} else {
			return null;
		}
	}

	pickerToggle = (bool) => {
		this.setState({
			isOpen: bool
		});
	}
}

PopOverCalendar.defaultProps = {
	disabled: false
}

export default PopOverCalendar;



// WEBPACK FOOTER //
// ./src/components/blueprintWrappers/PopOverCalendar.js